import { space, tok, tokPx } from '@sunwebgroup/ui-components'
import { focusOutline, Icon, modDisabled as modDisalbedUtil } from '@sunwebgroup/ui-components/uds'
import { css, styled } from 'styled-components'

export const Root = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`

export const Box = styled.div<{ $hasValue?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  ${(props) => {
    const paddingLeft = props.$hasValue ? space('primitives_space_6') : space('primitives_space_16')
    return css`padding: ${space('primitives_space_12')} ${space('primitives_space_16')} ${space('primitives_space_12')} ${paddingLeft}`
  }};

  cursor: pointer;
  box-sizing: border-box;
  border: ${tokPx('semantics_dividers_tickness')} solid ${tok('semantics_input_fields_border_color')};
  border-radius: ${tokPx('semantics_controls_m_corner_radius')};
  height: ${tokPx('semantics_controls_m_min_height')};
  background-color: ${tok('semantics_input_fields_background_color')};

  &:hover {
    border-color: ${tok('semantics_input_fields_hover_border_color')};
  }

  ${focusOutline()}
  /**
    Force iOS to not zoom in on inputs when they are focused.
    https://css-tricks.com/16px-or-larger-text-prevents-ios-form-zoom/
  */
  font-size: 16px;
`

export const Content = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;

  &::after {
    position: absolute;
    content: '';
    height: 100%;
    right: 0;
    top: 0;
    width: 54px;
    background: linear-gradient(
      270deg,
      ${tok('semantics_input_fields_background_color')} 0%,
      ${tok('semantics_input_fields_background_color')} 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`

const ChevronDownWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  height: 44px;
  width: 44px;
`

export function ChevronDown() {
  return (
    <ChevronDownWrapper>
      <Icon glyph="ChevronDown" size={20} />
    </ChevronDownWrapper>
  )
}

export function modDisabled() {
  return css`
  ${Box} {
    ${modDisalbedUtil(true)}
  }

  ${Content}::after {
    background: linear-gradient(
      270deg,
      ${tok('semantics_input_fields_background_color')} 0%,
      ${tok('semantics_input_fields_background_color')} 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  ${ChevronDownWrapper} {
    ${modDisalbedUtil(true)}
  }
`
}
